export default __webpack_public_path__ + "static/media/image3.27cfb723.jpg";